import {
  AppstoreOutlined,
  CrownOutlined,
  FileSyncOutlined,
  FontColorsOutlined,
  GiftOutlined,
  GroupOutlined,
  PieChartOutlined,
  PlaySquareOutlined,
  SettingOutlined,
  SolutionOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

const dashBoardNavTree = [
  {
    key: 'home',
    path: `${APP_PREFIX_PATH}/home`,
    title: 'sidenav.dashboard',
    icon: PieChartOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'playlist',
    path: `${APP_PREFIX_PATH}/playlist`,
    title: 'sidenav.playlist',
    icon: PlaySquareOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'report',
    path: '',
    submenu: [
      {
        key: 'report.submenu',
        title: 'sidenav.reports',
        icon: FileSyncOutlined,
        path: '',
        breadcrumb: false,
        submenu: [
          {
            key: 'report.athlete',
            path: `${APP_PREFIX_PATH}/report/athlete`,
            title: 'sidenav.reports.athlete',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.student',
            path: `${APP_PREFIX_PATH}/report/student`,
            title: 'sidenav.reports.student',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.coupon',
            path: `${APP_PREFIX_PATH}/report/coupon`,
            title: 'sidenav.reports.coupon',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.free.content',
            path: `${APP_PREFIX_PATH}/report/free-content`,
            title: 'sidenav.reports.free_content',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.wallet.balance',
            path: `${APP_PREFIX_PATH}/report/user-balance`,
            title: 'sidenav.reports.wallet_balance',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.cancellations',
            path: `${APP_PREFIX_PATH}/report/cancellation`,
            title: 'sidenav.reports.cancellation',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.referral.code',
            path: `${APP_PREFIX_PATH}/report/referral-code`,
            title: 'sidenav.reports.referral_code',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.referral.bunny',
            path: `${APP_PREFIX_PATH}/report/videos-bunny`,
            title: 'sidenav.reports.bunny',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.referral.sales',
            path: `${APP_PREFIX_PATH}/report/sales`,
            title: 'sidenav.reports.sales',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'report.subscription.sales',
            path: `${APP_PREFIX_PATH}/report/subscription-sales`,
            title: 'sidenav.reports.subscription_sales',
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: 'finance',
    path: '',
    submenu: [
      {
        key: 'finance.submenu',
        title: 'sidenav.finance',
        icon: WalletOutlined,
        path: '',
        breadcrumb: false,
        submenu: [
          {
            key: 'finance.distribution',
            path: `${APP_PREFIX_PATH}/finance/distribution`,
            title: 'sidenav.finance.distribution',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'finance.payment',
            path: `${APP_PREFIX_PATH}/finance/payment`,
            title: 'sidenav.finance.payment',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'finance.movements',
            path: `${APP_PREFIX_PATH}/finance/movement`,
            title: 'sidenav.finance.movements',
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: 'category',
    path: `${APP_PREFIX_PATH}/categories`,
    title: 'sidenav.category',
    icon: AppstoreOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'testimonials',
    path: `${APP_PREFIX_PATH}/testimonials`,
    title: 'sidenav.testimonials',
    icon: SolutionOutlined,
    breadcrumb: false,
    submenu: [],
  },
  {
    key: 'settings',
    path: '',
    submenu: [
      {
        key: 'settings.submenu',
        title: 'sidenav.settings',
        icon: SettingOutlined,
        path: '',
        breadcrumb: false,
        submenu: [
          {
            key: 'settings.banners',
            path: `${APP_PREFIX_PATH}/settings/banners`,
            title: 'sidenav.settings.banners',
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },

  {
    key: 'groupsandtypes',
    path: '',
    submenu: [
      {
        key: 'groupsandtypes.submenu',
        title: 'sidenav.groupsandtypes',
        icon: GroupOutlined,
        path: '',
        breadcrumb: false,
        submenu: [
          {
            key: 'groupsandtypes.groups',
            path: `${APP_PREFIX_PATH}/groupsandtypes/groups`,
            title: 'sidenav.groupsandtypes.groups',
            breadcrumb: false,
            submenu: [],
          },
          {
            key: 'groupsandtypes.types',
            path: `${APP_PREFIX_PATH}/groupsandtypes/types`,
            title: 'sidenav.groupsandtypes.types',
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
    ],
  },

  // {
  //   key: 'revenue',
  //   path: `${APP_PREFIX_PATH}/revenue`,
  //   title: 'sidenav.revenue',
  //   icon: WalletOutlined,
  //   breadcrumb: false,
  //   submenu: [],
  // },
  {
    key: 'management',
    title: 'sidenav.management',
    path: '/#',
    icon: UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: 'management-users',
        title: 'sidenav.users',
        path: `${APP_PREFIX_PATH}/user`,
        icon: UsergroupAddOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'management-students',
        title: 'sidenav.students',
        path: `${APP_PREFIX_PATH}/student`,
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'management-coupons',
        title: 'sidenav.coupons',
        path: `${APP_PREFIX_PATH}/coupon`,
        icon: FontColorsOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'management-plans',
        title: 'sidenav.plans',
        path: `${APP_PREFIX_PATH}/plans`,
        icon: CrownOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: 'management-offers',
        title: 'sidenav.offers',
        path: `${APP_PREFIX_PATH}/offer`,
        icon: GiftOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
